export default {
  /**
   * 判断是否是微信浏览器环境
   *
   * @export
   * @returns
   */
  get isWp() {
    return !!/micromessenger/.test(navigator.userAgent.toLowerCase());
  }
};
